import React from "react";
import AddRemoveUserAdmin from "./AddRemoveUserAdmin";

const UserDetails = () => {
  return <AddRemoveUserAdmin role="user" />;
};

export default UserDetails;
